<template>
  <a-modal
    v-model="showModal"
    title="View Faqset"
    :footer="null"
    width="500px"
    :destroyOnClose="true"
    class="view-faqset-modal"
  >
    <FaqsetSkeleton v-if="loading" />
    <div v-else-if="!hasItems" class="mb-3">
      <Empty>
        <span slot="description" class="text-default">None available faqsets</span>
      </Empty>
    </div>
    <a-tabs v-else type="card" class="mb-2">
      <a-tab-pane
        v-for="(translation, index) in translations"
        :key="index"
        force-render
      >
        <template #tab>
          <DefaultLabelTab
            :name="translation.tab_name"
            :is_default="translation.is_default"
          />
        </template>
        <div class="tab-content-container">
          <div
            v-for="item in translation.items"
            :key="item.id"
            class="d-flex"
          >
            <a-collapse accordion class="w-full">
              <a-collapse-panel
                :key="item.id"
                :header="item.name"
              >
                <p>{{ item.description }}</p>
              </a-collapse-panel>
            </a-collapse>
          </div>
        </div>
      </a-tab-pane>
    </a-tabs>
    <a-row class="footer-viewscreen footer d-flex justify-content-end">
      <a-button type="primary" @click="closeModal">OK</a-button>
    </a-row>
  </a-modal>
</template>

<script>
import apiClient from '@/services/axios'
import DefaultLabelTab from '@/views/apps/referral-program/components/DefaultLabelTab.vue'
import FaqsetSkeleton from './FaqsetSkeleton.vue'
import { Empty } from 'ant-design-vue'
import { getErrorMessage } from '@/views/apps/fortune-wheel/composables/useGetErrorMessage.js'
import { subscribe, unsubscribe } from '@/composables/keydownEvent.js'

const referralApiUrl = process.env.VUE_APP_REFERRAl_API_URL

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    languagesUsed: {
      type: Array,
      default: () => [],
    },
    selectedFaqset: {
      type: Object,
      default: null,
    },
  },
  components: {
    DefaultLabelTab,
    FaqsetSkeleton,
    Empty,
  },
  data: () => ({
    showModal: false,
    translations: [],
    faqset: {
      name: '',
      role: {
        name: '',
      },
      items: [],
    },
    loading: true,
  }),
  watch: {
    show: {
      handler(val) {
        if (val) {
          this.showModal = true
        } else {
          this.showModal = false
        }
      },
      deep: true,
      immediate: true,
    },
    showModal: {
      handler(val) {
        if (!val) {
          this.closeModal()
        }
      },
      deep: true,
    },
  },
  computed: {
    hasItems() {
      return !!this.faqset?.items?.length
    },
  },
  methods: {
    async getFaqSet() {
      try {
        this.loading = true

        const url = `${referralApiUrl}/faq-sets/${this.selectedFaqset.id}`
        const response = await apiClient.get(url)
        const { data } = response?.data
        if (data) {
          this.faqset = { ...this.faqset, ...data }
          this.templateDataFilling()
          return
        }
        getErrorMessage(response?.data)
        return null
      } catch (e) {
        this.$notification.error({
          message: e?.message ? e.message : 'Error',
        })
      } finally {
        this.loading = false
      }
    },
    templateDataFilling() {
      if (!this.hasItems) {
        return
      }

      const groupedItems = {}

      this.faqset.items.forEach(item => {
        const langId = item.language.id
        if (!groupedItems[langId]) {
          groupedItems[langId] = {
            language_id: langId,
            tab_name: item.language.name,
            is_default: item.language.is_default,
            items: [],
          }
        }
        groupedItems[langId].items.push({
          id: item.id,
          name: item.name,
          description: item.description,
        })
      })

      this.translations = Object.values(groupedItems).sort((a, b) => b.is_default - a.is_default)
    },
    clearForm() {
      this.translations = []
    },
    closeModal() {
      this.$emit('close')
      setTimeout(() => {
        this.clearForm()
      }, 500)
    },
  },
  mounted() {
    this.getFaqSet()
    subscribe(this.closeModal)
  },
  beforeDestroy() {
    unsubscribe()
  },
}
</script>

<style lang="scss">
.view-faqset-modal {
  .tab-content-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-height: 500px;
    overflow-y: scroll;
  }

  .ant-tabs-card > .ant-tabs-content {
    margin-top: -16px;
  }

  .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
    padding: 16px 8px 8px;
    border-right: 1px solid #e4e9f0;
    border-bottom: 1px solid #e4e9f0;
    border-left: 1px solid #e4e9f0;
    border-radius: 0 0 4px 4px;
  }

  .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
    border-color: transparent;
    background: transparent;
    margin-right: 0 !important;
  }

  .footer {
    display: flex;
    justify-content: space-between;
    &::before,
    &::after {
      content: none;
    }
  }
}
</style>
